export const generateTestId = (dataTestId: string) => ({
  component: dataTestId,
});

export const variants = {
  h1: 'h1' as const,
  h2: 'h2' as const,
  h3: 'h3' as const,
  h4: 'h4' as const,
  h5: 'h5' as const,
  h6: 'h6' as const,
  subtitle1: 'h6' as const,
  subtitle2: 'h6' as const,
  body1: 'p' as const,
  body2: 'p' as const,
  label: 'label' as const,
  caption: 'p' as const,
  helperText: 'span' as const,
};

export const variantsClassName = {
  h1: 'text-7xl',
  h2: 'text-6xl',
  h3: 'text-5xl',
  h4: 'text-4xl',
  h5: 'text-3xl',
  h6: 'text-2xl',
  subtitle1: 'text-xl',
  subtitle2: 'text-lg ',
  body1: 'text-base',
  body2: 'text-sm',
  label: 'text-sm',
  caption: 'text-xs',
  helperText: 'text-[10px]',
};

export const colorsClassName = {
  inherit: 'inherit',
  primary: 'text-primary-900 dark:text-white',
  secondary: 'text-secondary-500',
  textPrimary: 'text-black',
  textSecondary: 'text-gray-800',
  accent: 'text-white',
  success: 'text-success-900',
  error: 'text-error-500',
  warning: 'text-warning-500',
};
